define(
  ['marionette', './../templates/avatar-card.html', 'components/avatar/index'],
  function (Marionette, avatarCardTpl, AvatarComponent) {
    return Marionette.LayoutView.extend({
      tagName: 'li',

      template: avatarCardTpl,

      regions: {
        avatar: '.js-avatar'
      },

      triggers: {
        'click a': 'click'
      },

      className: function () {
        var classes = []
        if (!this.model.get('visible')) classes.push('is-hidden')
        if (this.model.get('selected')) classes.push('selected')
        return classes.join(' ')
      },

      onClick: function () {
        this.trigger('user:select', this.model)
      },

      changeVisibility: function () {
        this.$el.toggleClass('is-hidden', !this.model.get('visible'))
      },

      changeSelect: function () {
        this.$el.toggleClass('selected', this.model.get('selected'))
      },

      onRender: function () {
        this.getRegion('avatar').show(
          new AvatarComponent({ size: 'm', model: this.model })
        )
        this.listenTo(
          this.model,
          'change:visible',
          this.changeVisibility.bind(this)
        )
        this.listenTo(
          this.model,
          'change:selected',
          this.changeSelect.bind(this)
        )
      },

      initialize: function () {
        this.model.set('selected', false)
      }
    })
  }
)
